import FieldDate from './classes/FieldDate';
import FieldFile from './classes/FieldFile';
import ProductFieldsLoader from './classes/ProductFieldsLoader';
import PriceManager from './pricing/PriceManager';
import PriceFormatter from './pricing/PriceFormatter';

jQuery(() => {
	if (typeof fpf_pro_front === 'undefined') {
		console.error('Required global fpf_pro_front is not defined');
		return;
	}

	const priceFormatter = new PriceFormatter(
		fpf_product.currency_format_num_decimals,
		fpf_product.currency_format_symbol,
		fpf_product.currency_format_decimal_sep,
		fpf_product.currency_format_thousand_sep,
		fpf_product.currency_format
	);

	const priceManager = new PriceManager(
		priceFormatter,
		parseFloat(fpf_product.fpf_product_price)
	);

	const init = () => {
		// Fields initialization.
		new FieldDate();
		new FieldFile();

		priceManager.init(fpf_product.fpf_fields);
		priceManager.initCalculatorState();

		// Conditional logic.
		jQuery('select.fpf-input-field, input.fpf-input-field').change();
	};

	// Run initialization when document is ready.
	init();

	// Fields loader for product variations (ajax).
	new ProductFieldsLoader();

	// Re-run initialization on fields ready event.
	jQuery(document).on('fpf_fields_ready', init);
});
